import { render, staticRenderFns } from "./lainatalot.vue?vue&type=template&id=20d700f6&"
import script from "./lainatalot.vue?vue&type=script&lang=js&"
export * from "./lainatalot.vue?vue&type=script&lang=js&"
import style0 from "./lainatalot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports